/**
 * github:https://github.com/surmon-china/vue-awesome-swiper
 */
import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

Vue.use(VueAwesomeSwiper)
